import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import useStateRef from 'react-usestateref';
import Carousel from "react-multi-carousel";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { DEFAULT_IMAGE_140 } from '../../middleware/types';

const YouMayAlso = (props) => {

    const [domainName, setdomainName, domainNameRef] = useStateRef(props.domainName)
    const [recommendedData, setRecommendedData, recommendedDataRef] = useStateRef(props.siteSpec)
    const carouselRef = useRef(null);
    const [disable, setDisable, disableRef] = useStateRef()

    const [currentSlides, setCurrentSlide, currentSlideRef] = useStateRef(0);
    const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef()
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5,
            partialVisibilityGutter: 20
        },
        desktop: {
            breakpoint: { max: 3000, min: 1023 },
            items: 5,
            partialVisibilityGutter: 20
        },
        tablet: {
            breakpoint: { max: 1023, min: 464 },
            items: 1,

        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,

        },
    };

    
    
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;

    }
    useEffect(() => {

        setScreenWidth(screen.width)
        

    }, [])

    useEffect(() => {
        console.log("screenWidth ", screenWidthRef.current);
        if (screenWidthRef.current < 1024) {
            console.log("screenWidthRef.current condition");
            if (document.querySelector("#ymalnextButton") != null) {
                console.log(" screenWidth ymalnextButton ", document.querySelector("#ymalnextButton"));
                const sliderButton = document.querySelector("#ymalnextButton");
                sliderButton.click();
            }
        }
    }, [screenWidthRef.current])

    const handlePreviousCarousel = () => {
        setCurrentSlide(currentSlideRef.current - 1);
        carouselRef.current.previous();
    };

    const handleNextCarousel = () => {
        setCurrentSlide(currentSlideRef.current + 1);
        carouselRef.current.next();
    };



    const handleQuickViewProductPage = (id) => {


        const productId = id;
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res !== null) {
                    var productDetatils = (JSON.parse(res.response)).response
                    props.quickviewCallback(productDetatils)
                    var modalElement = document.getElementById(`${productId ? productId : "quickViewModal"}`);
                    var bootstrapModal = new bootstrap.Modal(modalElement);
                    bootstrapModal.show();
                } else {
                    //setIsLoading(false)
                    //const error = res._ERROR_MESSAGE_;
                    //setErrorMessage(error);
                    //document.getElementById("login-message-error-div").classList.remove("d-none");
                    // console.log("errorMessage ---->>>>!!!!", errorMessage)
                }
            })
    }


    return (
        <div className="">
            {recommendedDataRef.current  && recommendedDataRef.current.length > 1 ?

                <div className=' youMayAlso row pdp-detail-info border-0 pdp-detail-moreinfo ymalPadding'>

                    <div className={`px-0 ${screenWidthRef.current > 1023 && recommendedData.length < responsive.desktop.items?"d-block":"d-none"}`}>
                        <div className="d-flex px-0 justify-content-between">
                            <h2 className=' '>You Might Also Be Interested In...</h2>

                            <div className={`${recommendedData.length > responsive.desktop.items == true ? "d-done" : "d-none"} my-auto d-none d-lg-block`}>
                                <button className={`cb-previous-button mx-4 disabled`} onClick={handlePreviousCarousel} >
                                    <svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
                                </button>
                                <button className={`cb-next-button `} onClick={handleNextCarousel} id="ymalnextButton" >
                                    <svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    {screenWidthRef.current >= 1024 ?
                        <Carousel
                            ref={carouselRef}
                            swipeable={true}
                            draggable={true}
                            showDots={false}
                            responsive={responsive}
                            ssr
                            arrows={true}
                            infinite={false}
                            customLeftArrow={<button className='customLeftArrow'><h2 className=' ymalTextPosition px-0'>You Might Also Be Interested In...</h2> <button className={`cb-previous-button mx-4 ymalPreviousButtonPosition`} >
                                <svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
                            </button></button>}
                            customRightArrow={<button className={`cb-next-button ymalnextButtonPosition `} >
                                <svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
                            </button>}
                            autoPlay={false}
                            renderArrowsWhenDisabled={true}
                            partialVisible={true}
                            autoPlaySpeed={0}
                            keyBoardControl={true}
                            transitionDuration={200}
                            removeArrowOnDeviceType={['']}
                            deviceType="desktop"
                            className='custom-carousel'
                            itemClass="custom-item-class"

                        >
                            {recommendedDataRef.current.map((value, key) => {
                                return (
                                    <div className="m-auto row mt-4 mb-5 cb-product-item-sty" style={{ overflow: key === 5 ? 'hidden' : 'visible' }} >
                                        <div key={key} className="">
                                            <div className="c-feature-product qv-model">
                                                <a className='w-100 cb-product-link' href={value && value.variantUrl && value.variantUrl.productUrl}>
                                                    <div className='d-flex'>
                                                        <img loading="lazy" width="140px" height="140px" onError={replaceImage} src={domainNameRef.current ? domainNameRef.current.concat(value && value.variantUrl && value.variantUrl.imageURL) : value && value.variantUrl && value.variantUrl.imageURL} alt="/images/fpo/product-140x140.gif" />
                                                    </div>
                                                    <h3 className=" my-2 cb-categoryName-title" dangerouslySetInnerHTML={{ __html: value && value.variantUrl && value.variantUrl.displayName }}></h3>
                                                </a>
                                                <p class="c-product-total">Item #{value && value.variantUrl && value.variantUrl.skuId}</p>
                                               
                                                {value && value.hidePrice && value.hidePrice == "true"  ?
                                                    <p class="c-product-price">
                                                        Call For Pricing
                                                    </p> : <>
                                                    {value && value.variantUrl && value.variantUrl.salePrice && value.variantUrl.salePrice != "$0.00" ?
                                                        <p class="c-product-price-affer">
                                                            <del><span class="c-product-old-price">{value.variantUrl.basePrice}</span></del> <span class="c-product-price-value">{value.variantUrl.salePrice}</span></p> :
                                                        value && value.variantUrl && value.variantUrl.itemPrice != "$0.00" ? <p className="my-0 cb-productPrice">{value && value.variantUrl && value.variantUrl.itemPrice}</p> : ""}
                                                        {value && value.variantUrl && value.variantUrl.retailPrice  && value.variantUrl.retailPrice != "$0.00"?
                                                            <p class="c-retail-label">
                                                                {`Retail `}
                                                                <del><span>{value && value.variantUrl && value.variantUrl.retailPrice}</span></del>
                                                            </p> : ""}
                                                    </>}
                                                {value && value.hidePrice && value.hidePrice == "false"  && value && value.variantUrl && value.variantUrl.qtyDiscountAvailable && value.variantUrl.qtyDiscountAvailable == true ?
                                                    <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
                                                {value && value.reviewURLAverage ?
                                                    <div class="cb-product-rating">
                                                        <img loading="lazy" src={`/images/stars/50/rating-${value.reviewURLAverage}_50.png`} alt="rating" />
                                                    </div> : ""}
                                                <p id="recommendedQuickView" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></p>
                                                <button className='btn quick-btn modal-link' onClick={() => handleQuickViewProductPage(value && value.variantUrl && value.variantUrl.skuId)}>Quick View</button>
                                            </div>
                                        </div>




                                    </div>
                                );
                            })}
                        </Carousel> : <Carousel
                            ref={carouselRef}
                            swipeable={true}
                            draggable={true}
                            showDots={false}
                            responsive={responsive}
                            ssr
                            infinite={false}
                            autoPlay={false}
                            autoPlaySpeed={0}
                            keyBoardControl={true}
                            transitionDuration={200}
                            removeArrowOnDeviceType={['desktop']}
                            deviceType="desktop"
                            className='custom-carousel'
                            itemClass="custom-item-class"
                            centerMode={true}

                        >
                            {recommendedDataRef.current.map((value, key) => {
                                return (
                                    <div className=" mobileSlider m-auto row mt-4 cb-product-item-sty" style={{ overflow: key === 5 ? 'hidden' : 'visible' }} >

                                        <div className="c-feature-product qv-model m-0">
                                            <a className=' cb-product-link' href={value && value.variantUrl && value.variantUrl.productUrl}>
                                                <div className=''>
                                                    <img loading="lazy" width="140px" height="140px" onError={replaceImage} src={domainNameRef.current ? domainNameRef.current.concat(value && value.variantUrl && value.variantUrl.imageURL) : value && value.variantUrl && value.variantUrl.imageURL} alt="/images/fpo/product-140x140.gif" />
                                                </div>
                                                <h3 className="w-100 my-2 mx-auto cb-categoryName-title" dangerouslySetInnerHTML={{ __html: value && value.variantUrl && value.variantUrl.displayName }}></h3>
                                            </a>
                                            <p class="c-product-total">Item #{value && value.variantUrl && value.variantUrl.skuId}</p>
                                            {value && value.hidePrice && value.hidePrice == "true"  ?
                                                    <p class="c-product-price">
                                                        Call For Pricing
                                                    </p> : <>
                                                    {value && value.variantUrl && value.variantUrl.salePrice && value.variantUrl.salePrice != "$0.00" ?
                                                        <p class="c-product-price-affer">
                                                            <del><span class="c-product-old-price">{value.variantUrl.basePrice}</span></del> <span class="c-product-price-value">{value.variantUrl.salePrice}</span></p> :
                                                        value && value.variantUrl && value.variantUrl.itemPrice != "$0.00" ? <p className="my-0 cb-productPrice">{value && value.variantUrl && value.variantUrl.itemPrice}</p> : ""}
                                                        {value && value.variantUrl && value.variantUrl.retailPrice && value.variantUrl.retailPrice != "$0.00" ?
                                                            <p class="c-retail-label">
                                                                {`Retail `}
                                                                <del><span>{value && value.variantUrl && value.variantUrl.retailPrice}</span></del>
                                                            </p> : ""}
                                                    </>}
                                                    {value && value.hidePrice && value.hidePrice == "false"  &&
                                            value && value.variantUrl && value.variantUrl.qtyDiscountAvailable && value.variantUrl.qtyDiscountAvailable == true ?
                                                <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
                                            {value && value.reviewURLAverage ?
                                                <div class="cb-product-rating">
                                                    <img loading="lazy" src={`/images/stars/50/rating-${value.reviewURLAverage}_50.png`} alt="rating" />
                                                </div> : ""}
                                            <p className="m-0" id="recommendedQuickView" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></p>
                                            <button className='btn quick-btn modal-link' onClick={() => handleQuickViewProductPage(value && value.variantUrl && value.variantUrl.skuId)}>Quick View</button>
                                        </div>

                                    </div>
                                );
                            })}
                        </Carousel>}
                </div> : ""}
        </div>
    )
}

export default YouMayAlso
